import { round as trueRound } from 'mathjs';

export function round(value: number, decimals: number): number {
  return trueRound(value, decimals) as number;
}
